import { NoteType, TaskNote } from '@bringg/types';
import './attachment-image.scss';
import React from 'react';

const AttachmentImage: React.FC<{ taskNote: TaskNote }> = ({ taskNote }) => {
	const url = taskNote.url.toString();
	return (
		<a href={url} className="attachment-link" target="_blank">
			{taskNote.type === NoteType.Document ? (
				<embed className="task-note-attachment-note-image document" src={url} />
			) : (
				<img className="task-note-attachment-note-image" src={url} />
			)}
		</a>
	);
};

export default AttachmentImage;
